const noMoreOpenRateAsAnEmailMarketingKpi = [
  {
    type: "paragraph",
    text: "The new iOS 15 update from Apple is introducing privacy features that will significantly impact how brands measure the success of their email campaigns. Open rates, a traditional metric used to gauge the effectiveness of email campaigns, will no longer be reliable, as the update to Apple OS allows users to turn off open email tracking. These changes will require brands to rethink their approach to deliverability, reporting, and content strategies, as the traditional metrics of open email rates are no longer reliable. This means that brands will need to shift their focus to other metrics such as click-through rates, website traffic, and online sales, to determine the success of their campaigns. Additionally, the ability for their fans to hide their IP addresses and email addresses may also make it more difficult for the company to reach its target audience.",
  },

  {
    type: "heading",
    text: "What Has Apple Changed?",
  },
  {
    type: "paragraph",
    text: "The new release of iOS (iOS 15) will allow users to:",
  },
  {
    type: "list",
    items: [
      "Close or turn off open tracking.",
      "Hide IP addresses.",
      "Hide email address.",
    ],
  },

  {
    type: "paragraph",
    text: "From their newsletter, it seems that the changes that Apple will make to iOS 15 will have the following features:",
  },

  {
    type: "list",
    items: [
      "Mail privacy protection –\nWith the introduction of privacy features in iOS 15, users have the option to hide their IP addresses and block third parties from tracking email open rates. This means that it will no longer be possible to accurately track email open rates for those users who have enabled these privacy features.",

      "Private VPN –\nBy using an iCloud+ subscription, users gain access to privacy-enhancing features, such as a private relay that works similar to a VPN and blocks websites from tracking users who have chosen to opt-in. This feature also allows users to see the websites that receive their data.",

      "Hide email id –\nWith this feature, users can provide a fictitious email address to a website, which can result in promotional messages being sent to an unintended recipient and not reaching the intended audience. Brands will not be able to obtain the user's actual email address until they fill out a contact form, which can affect the success of email marketing efforts.",

      "Some of the above features are expected to be given via paid subscription. However, the free feature also will be of significant concern for email marketers.",
    ],
  },

  {
    type: "heading",
    text: "Impact On Email Marketing",
  },
  {
    type: "paragraph",
    text: "With open rates no longer remaining a reliable metric, all strategies that depend upon it, such as retention and re-engagement, will need to be changed. Most of the campaign and automation workflows will need to be changed to get the desired outcomes. Here are some ways that the impact of unreliable open rates can be countered.",
  },

  {
    type: "heading",
    text: "Use other email marketing metrics",
  },
  {
    type: "paragraph",
    text: "There are a ton of other email marketing metrics that can still be used even if open rates are not available. Some of the most popular ones are:",
  },
  {
    type: "list",
    items: [
      "Click-through rates",
      "Website traffic",
      "The size of your email list",
      "Unsubscribe rates",
      "Signup data",
      "Survey data",
      "Purchases and orders",
    ],
  },
  {
    type: "paragraph",
    text: "These metrics offer great insights while optimizing the emails effectively and are more focused on the end results as compared to open rates.",
  },

  {
    type: "heading",
    text: "A/B Testing",
  },
  {
    type: "paragraph",
    text: "It is a good time to test different versions of your emails to see what works best with your audience. This will help you find the best ways to create emails that lead to more conversions.",
  },
  {
    type: "paragraph",
    text: "Here are a few elements to test:",
  },
  {
    type: "list",
    items: [
      "Length of emails",
      "Emoji usage",
      "Popular formulas, such as statement vs. question subject lines",
      "Trending topics",
      "Figures/statistics",
      "Personalization",
    ],
  },

  {
    type: "heading",
    text: "Send Personal Email",
  },
  {
    type: "paragraph",
    text: "Send emails from a personalized email ID rather than from a brand name. This is one of the rarely used techniques, but it works efficiently. With newer email tools available, creating personal ids and sending mail from then, and yet being able to track the mail en masse, is a piece of cake.",
  },

  {
    type: "heading",
    text: "Use Non-Apple Mail Id Users",
  },
  {
    type: "paragraph",
    text: "Every person today pretty much has at least 2 or 3 email ids from different service providers. (who doesn't use gmail today!)  It may be a good time to review the list, find the inactive contacts, and improve the general hygiene of the list. After that, make two sets of KPIs. One for apple ids and another one for non-apple Ids. Experiment and adopt a different strategy for Apple ids. Apple has not blocked any click-throughs. So the email traffic reports by website analytic tools should still work.",
  },
];

export default noMoreOpenRateAsAnEmailMarketingKpi;
